import { render, staticRenderFns } from "./hardware-summary-table.vue?vue&type=template&id=3bfe2092&scoped=true&"
import script from "./hardware-summary-table.vue?vue&type=script&lang=js&"
export * from "./hardware-summary-table.vue?vue&type=script&lang=js&"
import style0 from "./hardware-summary-table.vue?vue&type=style&index=0&id=3bfe2092&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfe2092",
  null
  
)

export default component.exports